export default {
    data() {
        return {
            list: []
        }
    },
    methods: {
        getList(url, data, returnKey) {
            return this.$http(url, data).then(res=>{
                if(res.returnCode == '1000') this.list = res[returnKey || 'records']
            })
        }
    }
}